import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import {
  Badge,
  Box,
  Tooltip as ChakraTooltip,
  Text as TextComponent,
} from '@chakra-ui/react';
import 'moment/locale/is';
import moment from 'moment';
import { IconArrowRight, IconChatbox } from 'components/Icons';
import { ActivityLogs } from 'api/types/types';
import { STATUS_MAPPER } from 'utils/statusUtils';
import { Tooltip } from 'components/Tooltip/Tooltip';

export const columns: ColumnDef<ActivityLogs>[] = [
  {
    accessorKey: 'id',
    enableSorting: true,
    maxSize: 180,
    header: () => <span>Aðili</span>,
    accessorFn: (row) => row,
    cell: ({ getValue }): JSX.Element => {
      const { updatedDate, updatedName, comment } = getValue() as any;
      const updateTime = moment(updatedDate).format('HH:mm');
      const updateDate = moment(updatedDate).format('DD.MM.YYYY');
      return (
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: '10px' }}>
            <div>
              <ChakraTooltip label={`${updateDate} kl. ${updateTime}`}>
                <span style={{ color: 'gray', fontSize: '90%' }}>
                  {updateDate} kl. {updateTime}
                </span>
              </ChakraTooltip>
            </div>
            <strong>{updatedName}</strong>
          </div>

          {comment && (
            <div style={{ marginLeft: '10px', color: 'gray' }}>
              <div>
                <strong>Athugasemd:</strong>
              </div>
              {comment}
            </div>

            // <Tooltip
            //   label={
            //     <>
            //       <TextComponent>
            //         <strong>Athugasemd:</strong>
            //       </TextComponent>
            //       {comment}
            //     </>
            //   }
            //   icon={
            //     <IconChatbox
            //       width={20}
            //       cursor="pointer"
            //       style={{ marginLeft: 10 }}
            //     />
            //   }
            // />
          )}
        </div>
      );
    },
  },
  {
    accessorKey: 'name',
    accessorFn: (row) => row,
    header: () => <span>Staða</span>,
    cell: ({ cell }): JSX.Element => {
      const { currentStatus, previousStatus } = cell.row.original as any;
      return (
        <ChakraTooltip label={STATUS_MAPPER[currentStatus].label}>
          <Box as="div" display="flex" flexDir="row">
            {previousStatus && (
              <Box as="div" display="flex" alignItems="center">
                <Badge
                  colorScheme={STATUS_MAPPER[previousStatus]?.color}
                  cursor="pointer"
                >
                  {STATUS_MAPPER[previousStatus]?.label}
                </Badge>
                <Box as="span" ml={2} mr={2}>
                  <IconArrowRight />
                </Box>
              </Box>
            )}
            <Badge
              colorScheme={STATUS_MAPPER[currentStatus]?.color}
              cursor="pointer"
            >
              {STATUS_MAPPER[currentStatus].label}
            </Badge>
          </Box>
        </ChakraTooltip>
      );
    },
  },
  {
    accessorKey: 'action',
    header: () => (
      <Box display="flex" marginLeft="auto">
        Aðgerðir
      </Box>
    ),
    cell: ({ cell }): JSX.Element => {
      const { status } = cell.row.original as any;
      const { description } = status;
      return (
        <Box float="right">
          <TextComponent>{description}</TextComponent>
        </Box>
      );
    },
  },
];
